import { Id, PolicyApprovalRules } from 'src/types'

type GetDefaultValuesProps = {
  organization_id: Id
  policy_approval_id: Id
}

export function getDefaultValues({
  organization_id,
  policy_approval_id
}: GetDefaultValuesProps): PolicyApprovalRules {
  return {
    active: true,
    code: '',
    include_original_approvers: false,
    name: '',
    organization_id,
    policy_approval_exception_trees: [],
    policy_approval_id,
    policy_approval_rule_id: `${new Date().toLocaleString()}`,
    policy_request_air_rule_id: '',
    policy_request_general_rule_id: '',
    policy_request_hotel_rule_id: '',
    policy_request_vehicle_rule_id: ''
  }
}

export const initialValues = {} as PolicyApprovalRules
